// Updated EditQuickConnectPage.jsx

import React, { useState, useEffect } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  CircularProgress,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Chip,
  IconButton
} from "@mui/material";
import { axiosInstance } from "../../../services/axiosInstance";
import { endpoints } from "../../../services/endpoint";
import {
  ArrowDropUp as ArrowDropUpIcon,
  AccountCircle,
  ArrowDropDown as ArrowDropDownIcon,
  ExpandMore as ExpandMoreIcon,
  ArrowBack as ArrowBackIcon,
} from "@mui/icons-material";
import "./editQuickConnect.css";
const countryCodes = [
  { label: "Afghanistan (+93)", value: "+93" },
  { label: "Aland Islands (+358)", value: "+358" },
  { label: "Albania (+355)", value: "+355" },
  { label: "Algeria (+213)", value: "+213" },
  { label: "American Samoa (+1)", value: "+1" },
  { label: "Andorra (+376)", value: "+376" },
  { label: "Angola (+244)", value: "+244" },
  { label: "Anguilla (+1)", value: "+1" },
  { label: "Antarctica (+0)", value: "+0" },
  { label: "Antigua And Barbuda (+1)", value: "+1" },
  { label: "Argentina (+54)", value: "+54" },
  { label: "Armenia (+374)", value: "+374" },
  { label: "Aruba (+297)", value: "+297" },
  { label: "Ascension Island (+247)", value: "+247" },
  { label: "Australia (+61)", value: "+61" },
  { label: "Austria (+43)", value: "+43" },
  { label: "Azerbaijan (+994)", value: "+994" },
  { label: "Bahamas (+1)", value: "+1" },
  { label: "Bahrain (+973)", value: "+973" },
  { label: "Bangladesh (+880)", value: "+880" },
  { label: "Barbados (+1)", value: "+1" },
  { label: "Belarus (+375)", value: "+375" },
  { label: "Belgium (+32)", value: "+32" },
  { label: "Belize (+501)", value: "+501" },
  { label: "Benin (+229)", value: "+229" },
  { label: "Bermuda (+1)", value: "+1" },
  { label: "Bhutan (+975)", value: "+975" },
  { label: "Bolivia (+591)", value: "+591" },
  { label: "Bosnia And Herzegovina (+387)", value: "+387" },
  { label: "Botswana (+267)", value: "+267" },
  { label: "Bouvet Island (+0)", value: "+0" },
  { label: "Brazil (+55)", value: "+55" },
  { label: "British Indian Ocean Territory (+246)", value: "+246" },
  { label: "Brunei Darussalam (+673)", value: "+673" },
  { label: "Bulgaria (+359)", value: "+359" },
  { label: "Burkina Faso (+226)", value: "+226" },
  { label: "Burundi (+257)", value: "+257" },
  { label: "Cambodia (+855)", value: "+855" },
  { label: "Cameroon (+237)", value: "+237" },
  { label: "Canada (+1)", value: "+1" },
  { label: "Cape Verde (+238)", value: "+238" },
  { label: "Cayman Islands (+1)", value: "+1" },
  { label: "Central African Republic (+236)", value: "+236" },
  { label: "Chad (+235)", value: "+235" },
  { label: "Chile (+56)", value: "+56" },
  { label: "China (+86)", value: "+86" },
  { label: "Christmas Island (+61)", value: "+61" },
  { label: "Cocos (Keeling) Islands (+61)", value: "+61" },
  { label: "Colombia (+57)", value: "+57" },
  { label: "Comoros (+269)", value: "+269" },
  { label: "Congo (+242)", value: "+242" },
  { label: "Congo, Democratic Republic (+243)", value: "+243" },
  { label: "Cook Islands (+682)", value: "+682" },
  { label: "Costa Rica (+506)", value: "+506" },
  { label: "Cote D'Ivoire (+225)", value: "+225" },
  { label: "Croatia (+385)", value: "+385" },
  { label: "Cuba (+53)", value: "+53" },
  { label: "Curacao (+599)", value: "+599" },
  { label: "Cyprus (+357)", value: "+357" },
  { label: "Czech Republic (+420)", value: "+420" },
  { label: "Denmark (+45)", value: "+45" },
  { label: "Diego Garcia (+0)", value: "+0" },
  { label: "Djibouti (+253)", value: "+253" },
  { label: "Dominica (+1)", value: "+1" },
  { label: "Dominican Republic (+1)", value: "+1" },
  { label: "Ecuador (+593)", value: "+593" },
  { label: "Egypt (+20)", value: "+20" },
  { label: "El Salvador (+503)", value: "+503" },
  { label: "Equatorial Guinea (+240)", value: "+240" },
  { label: "Eritrea (+291)", value: "+291" },
  { label: "Estonia (+372)", value: "+372" },
  { label: "Ethiopia (+251)", value: "+251" },
  { label: "Falkland Islands (+500)", value: "+500" },
  { label: "Faroe Islands (+298)", value: "+298" },
  { label: "Fiji (+679)", value: "+679" },
  { label: "Finland (+358)", value: "+358" },
  { label: "France (+33)", value: "+33" },
  { label: "French Guiana (+594)", value: "+594" },
  { label: "French Polynesia (+689)", value: "+689" },
  { label: "French Southern Territories (+0)", value: "+0" },
  { label: "Gabon (+241)", value: "+241" },
  { label: "Gambia (+220)", value: "+220" },
  { label: "Georgia (+995)", value: "+995" },
  { label: "Germany (+49)", value: "+49" },
  { label: "Ghana (+233)", value: "+233" },
  { label: "Gibraltar (+350)", value: "+350" },
  { label: "Greece (+30)", value: "+30" },
  { label: "Greenland (+299)", value: "+299" },
  { label: "Grenada (+1)", value: "+1" },
  { label: "Guadeloupe (+590)", value: "+590" },
  { label: "Guam (+1)", value: "+1" },
  { label: "Guatemala (+502)", value: "+502" },
  { label: "Guernsey (+44)", value: "+44" },
  { label: "Guinea (+224)", value: "+224" },
  { label: "Guinea-Bissau (+245)", value: "+245" },
  { label: "Guyana (+592)", value: "+592" },
  { label: "Haiti (+509)", value: "+509" },
  { label: "Heard Island & Mcdonald Islands (+0)", value: "+0" },
  { label: "Holy See (Vatican City State) (+39)", value: "+39" },
  { label: "Honduras (+504)", value: "+504" },
  { label: "Hong Kong (+852)", value: "+852" },
  { label: "Hungary (+36)", value: "+36" },
  { label: "Iceland (+354)", value: "+354" },
  { label: "India (+91)", value: "+91" },
  { label: "Indonesia (+62)", value: "+62" },
  { label: "Iran, Islamic Republic Of (+98)", value: "+98" },
  { label: "Iraq (+964)", value: "+964" },
  { label: "Ireland (+353)", value: "+353" },
  { label: "Isle Of Man (+44)", value: "+44" },
  { label: "Israel (+972)", value: "+972" },
  { label: "Italy (+39)", value: "+39" },
  { label: "Jamaica (+1)", value: "+1" },
  { label: "Japan (+81)", value: "+81" },
  { label: "Jersey (+44)", value: "+44" },
  { label: "Jordan (+962)", value: "+962" },
  { label: "Kazakhstan (+7)", value: "+7" },
  { label: "Kenya (+254)", value: "+254" },
  { label: "Kiribati (+686)", value: "+686" },
  { label: "Korea (+82)", value: "+82" },
  { label: "Kuwait (+965)", value: "+965" },
  { label: "Kyrgyzstan (+996)", value: "+996" },
  { label: "Lao People's Democratic Republic (+856)", value: "+856" },
  { label: "Latvia (+371)", value: "+371" },
  { label: "Lebanon (+961)", value: "+961" },
  { label: "Lesotho (+266)", value: "+266" },
  { label: "Liberia (+231)", value: "+231" },
  { label: "Libyan Arab Jamahiriya (+218)", value: "+218" },
  { label: "Liechtenstein (+423)", value: "+423" },
  { label: "Lithuania (+370)", value: "+370" },
  { label: "Luxembourg (+352)", value: "+352" },
  { label: "Macao (+853)", value: "+853" },
  { label: "Macedonia (+389)", value: "+389" },
  { label: "Madagascar (+261)", value: "+261" },
  { label: "Malawi (+265)", value: "+265" },
  { label: "Malaysia (+60)", value: "+60" },
  { label: "Maldives (+960)", value: "+960" },
  { label: "Mali (+223)", value: "+223" },
  { label: "Malta (+356)", value: "+356" },
  { label: "Marshall Islands (+692)", value: "+692" },
  { label: "Martinique (+596)", value: "+596" },
  { label: "Mauritania (+222)", value: "+222" },
  { label: "Mauritius (+230)", value: "+230" },
  { label: "Mayotte (+262)", value: "+262" },
  { label: "Mexico (+52)", value: "+52" },
  { label: "Micronesia, Federated States Of (+691)", value: "+691" },
  { label: "Moldova (+373)", value: "+373" },
  { label: "Monaco (+377)", value: "+377" },
  { label: "Mongolia (+976)", value: "+976" },
  { label: "Montenegro (+382)", value: "+382" },
  { label: "Montserrat (+1)", value: "+1" },
  { label: "Morocco (+212)", value: "+212" },
  { label: "Mozambique (+258)", value: "+258" },
  { label: "Myanmar (+95)", value: "+95" },
  { label: "Namibia (+264)", value: "+264" },
  { label: "Nauru (+674)", value: "+674" },
  { label: "Nepal (+977)", value: "+977" },
  { label: "Netherlands (+31)", value: "+31" },
  { label: "Netherlands Antilles (+0)", value: "+0" },
  { label: "New Caledonia (+687)", value: "+687" },
  { label: "New Zealand (+64)", value: "+64" },
  { label: "Nicaragua (+505)", value: "+505" },
  { label: "Niger (+227)", value: "+227" },
  { label: "Nigeria (+234)", value: "+234" },
  { label: "Niue (+683)", value: "+683" },
  { label: "Norfolk Island (+672)", value: "+672" },
  { label: "Northern Mariana Islands (+1)", value: "+1" },
  { label: "Norway (+47)", value: "+47" },
  { label: "Oman (+968)", value: "+968" },
  { label: "Pakistan (+92)", value: "+92" },
  { label: "Palau (+680)", value: "+680" },
  { label: "Palestinian Territory, Occupied (+970)", value: "+970" },
  { label: "Panama (+507)", value: "+507" },
  { label: "Papua New Guinea (+675)", value: "+675" },
  { label: "Paraguay (+595)", value: "+595" },
  { label: "Peru (+51)", value: "+51" },
  { label: "Philippines (+63)", value: "+63" },
  { label: "Pitcairn (+0)", value: "+0" },
  { label: "Poland (+48)", value: "+48" },
  { label: "Portugal (+351)", value: "+351" },
  { label: "Puerto Rico (+1)", value: "+1" },
  { label: "Qatar (+974)", value: "+974" },
  { label: "Reunion (+262)", value: "+262" },
  { label: "Romania (+40)", value: "+40" },
  { label: "Russian Federation (+7)", value: "+7" },
  { label: "Rwanda (+250)", value: "+250" },
  { label: "Saint Barthelemy (+590)", value: "+590" },
  { label: "Saint Helena (+290)", value: "+290" },
  { label: "Saint Kitts And Nevis (+1)", value: "+1" },
  { label: "Saint Lucia (+1)", value: "+1" },
  { label: "Saint Martin (+590)", value: "+590" },
  { label: "Saint Pierre And Miquelon (+508)", value: "+508" },
  { label: "Saint Vincent And Grenadines (+1)", value: "+1" },
  { label: "Samoa (+685)", value: "+685" },
  { label: "San Marino (+378)", value: "+378" },
  { label: "Sao Tome And Principe (+239)", value: "+239" },
  { label: "Saudi Arabia (+966)", value: "+966" },
  { label: "Senegal (+221)", value: "+221" },
  { label: "Serbia (+381)", value: "+381" },
  { label: "Seychelles (+248)", value: "+248" },
  { label: "Sierra Leone (+232)", value: "+232" },
  { label: "Singapore (+65)", value: "+65" },
  { label: "Sint Maarten (+1)", value: "+1" },
  { label: "Slovakia (+421)", value: "+421" },
  { label: "Slovenia (+386)", value: "+386" },
  { label: "Solomon Islands (+677)", value: "+677" },
  { label: "Somalia (+252)", value: "+252" },
  { label: "South Africa (+27)", value: "+27" },
  { label: "South Georgia And Sandwich Isl. (+0)", value: "+0" },
  { label: "South Sudan (+211)", value: "+211" },
  { label: "Spain (+34)", value: "+34" },
  { label: "Sri Lanka (+94)", value: "+94" },
  { label: "Sudan (+249)", value: "+249" },
  { label: "Suriname (+597)", value: "+597" },
  { label: "Svalbard And Jan Mayen (+47)", value: "+47" },
  { label: "Swaziland (+268)", value: "+268" },
  { label: "Sweden (+46)", value: "+46" },
  { label: "Switzerland (+41)", value: "+41" },
  { label: "Syrian Arab Republic (+963)", value: "+963" },
  { label: "Taiwan (+886)", value: "+886" },
  { label: "Tajikistan (+992)", value: "+992" },
  { label: "Tanzania (+255)", value: "+255" },
  { label: "Thailand (+66)", value: "+66" },
  { label: "Timor-Leste (+670)", value: "+670" },
  { label: "Togo (+228)", value: "+228" },
  { label: "Tokelau (+690)", value: "+690" },
  { label: "Tonga (+676)", value: "+676" },
  { label: "Trinidad And Tobago (+1)", value: "+1" },
  { label: "Tunisia (+216)", value: "+216" },
  { label: "Turkey (+90)", value: "+90" },
  { label: "Turkmenistan (+993)", value: "+993" },
  { label: "Turks And Caicos Islands (+1)", value: "+1" },
  { label: "Tuvalu (+688)", value: "+688" },
  { label: "Uganda (+256)", value: "+256" },
  { label: "Ukraine (+380)", value: "+380" },
  { label: "United Arab Emirates (+971)", value: "+971" },
  { label: "United Kingdom (+44)", value: "+44" },
  { label: "United States (+1)", value: "+1" },
  { label: "United States Outlying Islands (+0)", value: "+0" },
  { label: "Uruguay (+598)", value: "+598" },
  { label: "Uzbekistan (+998)", value: "+998" },
  { label: "Vanuatu (+678)", value: "+678" },
  { label: "Venezuela (+58)", value: "+58" },
  { label: "Viet Nam (+84)", value: "+84" },
  { label: "Virgin Islands, British (+1)", value: "+1" },
  { label: "Virgin Islands, U.S. (+1)", value: "+1" },
  { label: "Wallis And Futuna (+681)", value: "+681" },
  { label: "Western Sahara (+212)", value: "+212" },
  { label: "Yemen (+967)", value: "+967" },
  { label: "Zambia (+260)", value: "+260" },
  { label: "Zimbabwe (+263)", value: "+263" },
  { label: "Wales (+0)", value: "+0" },
  { label: "Scotland (+0)", value: "+0" },
  { label: "England (+0)", value: "+0" },
  { label: "Catalonia (+0)", value: "+0" }
];

const EditQuickConnectPage = ({ data, onClose, onEditSuccess }) => {
  const [name, setName] = useState(data.name || "");
  const [description, setDescription] = useState(data.description || "");
  const [connectType, setConnectType] = useState(data.quickConnectType || "");
  const [searchUser, setSearchUser] = useState(data.userName || "");
  const [searchQueue, setSearchQueue] = useState(data.queueName || "");
  const [queueFlow, setQueueFlow] = useState(data.contactFlowName || "");
  const [flow, setFlow] = useState(data.contactFlowName || "");
  const [phoneNumber, setPhoneNumber] = useState(data.phoneNumber || "");
  const [countryCode, setCountryCode] = useState("+91");
  const [tags] = useState(data.tags || {});
  const [loading, setLoading] = useState(false);
  const [cancelButtonLoading, setCancelButtonLoading] = useState(false);

  const [queueList, setQueueList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [actionClicked, setActionClicked] = useState(null); 
    const [errors, setErrors] = useState({});
  const instanceAlias = localStorage.getItem("instanceName");
  const instanceId = localStorage.getItem("InstanceId");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const region = localStorage.getItem("Region");
  const EncryptedInstanceId = localStorage.getItem("EncryptedId");
  const email = localStorage.getItem("Email");
  const username = localStorage.getItem("username");

  /** Fetch queue list */
  const fetchQueueList = async () => {
    const payload = {
      Action: "listQueues",
      ID: instanceId,
      awsAccount: customerAWSAccountId,
      region: region,
    };

    try {
      const response = await axiosInstance.post(
        endpoints.displayQueuelist.quickQueue,
        payload
      );

      const parsedBody = JSON.parse(response.data.body);
      if (Array.isArray(parsedBody)) {
        return parsedBody.map((queue) => ({ queueName: queue }));
      } else {
        console.error("Unexpected queue list response:", parsedBody);
        return [];
      }
    } catch (error) {
      console.error("Fetch Queue List Error:", error.response?.data || error.message);
      return [];
    }
  };

  /** Fetch user list */
  const fetchQuickConnectUsers = async () => {
    const payload = {
      Action: "listUsers",
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      InstanceAlias: instanceAlias,
      region: "us-west-2",
    };

    try {
      const response = await axiosInstance.post(
        endpoints.listquickConnectUser.listUsers,
        payload
      );

      const parsedBody = JSON.parse(response.data.body);
      if (Array.isArray(parsedBody)) {
        return parsedBody.map((user) => ({ userName: user }));
      } else {
        console.error("Unexpected user list response:", parsedBody);
        return [];
      }
    } catch (error) {
      console.error("Fetch Users Error:", error.response?.data || error.message);
      return [];
    }
  };

  // 🔧 FIXED: Updated fetchQuickConnects function with proper scope
    const fetchQuickConnects = async () => {
    const payload = {
      Action: "list",
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region,
      InstanceAlias: instanceAlias,
    };
  
    try {
      const res = await axiosInstance.post(
        endpoints.displayquickConnects.quickConnects,
        payload
      );
  
      const rawBody = res?.data?.body;
      if (!rawBody) {
        console.warn("QuickConnects: response body is undefined or empty");
        return [];
      }
  
      let parsed;
      try {
        parsed = JSON.parse(rawBody);
      } catch (err) {
        console.error("Failed to parse QuickConnects JSON:", err);
        return [];
      }
  
      const dataArray = Array.isArray(parsed)
        ? parsed
        : parsed.QuickConnects || parsed.quickConnects || [];
  
      const extractedData = dataArray.map((item) => {
    const config = item.QuickConnectConfig || {};
  
    return {
      quickConnectARN: item.QuickConnectARN,
      quickConnectId: item.QuickConnectId,
      name: item.Name,
      description: item.Description || "",
      quickConnectType: config.QuickConnectType || "",
  
      // ✅ Prefer names when IDs are missing
      queueId: config.QueueConfig?.QueueId || "",
      queueName: item.QueueName || config.QueueConfig?.QueueName || "—",
  
      userId: config.UserConfig?.UserId || "",
      userName: item.UserName || config.UserConfig?.UserName || "—",
  
      contactFlowId:
        config.QueueConfig?.ContactFlowId ||
        config.UserConfig?.ContactFlowId ||
        "",
      contactFlowName:
        item.ContactFlowName ||
        config.QueueConfig?.ContactFlowName ||
        config.UserConfig?.ContactFlowName ||
        "—",
  
      phoneNumber: config.PhoneConfig?.PhoneNumber || "—",
  
      tags: item.Tags || {},
      lastModifiedTime: item.LastModifiedTime || "",
      lastModifiedRegion: item.LastModifiedRegion || "",
    };
  })
  
      console.log("📊 Extracted Quick Connects:", extractedData);
      return extractedData;
    } catch (error) {
      console.error("Error fetching quick connects:", error);
      return [];
    }
  };
  
  /** Load queue & user data on mount */
  useEffect(() => {
    const loadData = async () => {
      const queues = await fetchQueueList();
      const users = await fetchQuickConnectUsers();
      if (queues) setQueueList(queues);
      if (users) setUserList(users);
    };
    loadData();
  }, []);

  // 🔧 FIXED: Extract phone number parts correctly
  useEffect(() => {
    if (data.phoneNumber) {
      // Extract country code and phone number
      const phone = data.phoneNumber;
      if (phone.startsWith('+91')) {
        setCountryCode('+91');
        setPhoneNumber(phone.substring(3));
      } else if (phone.startsWith('+1')) {
        setCountryCode('+1');
        setPhoneNumber(phone.substring(2));
      } else if (phone.startsWith('+44')) {
        setCountryCode('+44');
        setPhoneNumber(phone.substring(3));
      } else {
        // Default case
        setPhoneNumber(phone);
      }
    }
  }, [data.phoneNumber]);

  /** Handle Save */
  // Inside EditQuickConnectPage

const handleSubmit = async () => {
  setActionClicked("save");
  setLoading(true);

  const isNameOrDescriptionChanged =
    name.trim() !== (data.name || "").trim() ||
    description.trim() !== (data.description || "").trim();

  let isConfigChanged = false;

  if (connectType !== (data.quickConnectType || "")) {
    isConfigChanged = true;
  } else if (connectType === "USER") {
    isConfigChanged =
      searchUser !== (data.userName || "") ||
      flow !== (data.contactFlowName || "");
  } else if (connectType === "QUEUE") {
    isConfigChanged =
      searchQueue !== (data.queueName || "") ||
      queueFlow !== (data.contactFlowName || "");
  } else if (connectType === "PHONE_NUMBER") {
    const originalPhone = data.phoneNumber || "";
    const newPhone = `${countryCode}${phoneNumber}`;
    isConfigChanged = newPhone !== originalPhone;
  }

  let action = null;
  if (isConfigChanged) {
    action = "updateqcconfig";
  } else if (isNameOrDescriptionChanged) {
    action = "updateqcnamedescription";
  }

  if (!action) {
    console.log("No changes detected.");
    setLoading(false);
    setActionClicked(null);
    return;
  }

  let payload = {};

  if (action === "updateqcnamedescription") {
    payload = {
      Action: "updateqcnamedescription",
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      InstanceAlias: instanceAlias,
      region,
      Name: data.name,
      NewName: name.trim() === (data.name || "").trim() ? "" : name,
      Description: description,
      Email: email,
      UserName: username,
    };
  } else if (action === "updateqcconfig") {
    const quickConnectConfig = {};

    if (connectType === "USER") {
      quickConnectConfig.UserConfig = {
        UserName: searchUser,
        ContactFlowName: flow,
      };
    } else if (connectType === "QUEUE") {
      quickConnectConfig.QueueConfig = {
        QueueName: searchQueue,
        ContactFlowName: queueFlow,
      };
    } else if (connectType === "PHONE_NUMBER") {
      quickConnectConfig.PhoneConfig = {
        PhoneNumber: `${countryCode}${phoneNumber}`,
      };
    }

    payload = {
      Action: "updateqcconfig",
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      InstanceAlias: instanceAlias,
      region,
      Name: data.name,
      QuickConnectConfig: quickConnectConfig,
      Email: email,
      UserName: username,
    };
  }

  console.log("🔄 Action:", action);
  console.log("📤 Payload:", payload);

  try {
    const res = await axiosInstance.post(
      endpoints.displayquickConnects.quickConnects,
      payload
    );

    if (res.status === 200) {
      console.log("✅ Update successful, fetching latest list...");

      // 🔄 Fetch full updated list
      const updatedList = await fetchQuickConnects();

      if (updatedList && Array.isArray(updatedList)) {
        console.log("📊 Sending updated list to parent:", updatedList);
        onEditSuccess(updatedList); // ✅ pass full updated list
      } else {
        console.warn("⚠️ Failed to fetch updated list");
      }

      onClose(); // Close edit modal
    } else {
      throw new Error("Update failed");
    }
  } catch (error) {
    console.error("❌ Failed to update quick connect", error);
    alert("Error while saving changes.");
  } finally {
    setLoading(false);
    setActionClicked(null);
  }
};

// Cancel handler
const handleCancel = () => {
  setActionClicked("cancel");
  setCancelButtonLoading(true);
  setTimeout(() => {
    setCancelButtonLoading(false);
    setActionClicked(null);
    onClose();
  }, 500);
};


  return (
    <div className="addhour-navbar-container">
      <Container className="addhour-content-container">
        <Box display="flex" flexDirection="column" alignItems="flex-start" mb={2} gap={1}>
          <IconButton
            onClick={onClose}
            size="medium"
            sx={{
              border: "1px solid #ccc",
              borderRadius: "50%",
              padding: 1,
              bgcolor: "#f5f5f5",
              "&:hover": { bgcolor: "#e0e0e0" }
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" className="phone-text">
            Edit Quick Connect
          </Typography>
        </Box>

        <Box className="form-section">
          <Box
            display="flex"
            gap={2}
            flexDirection={{ xs: "column", sm: "row" }}
            width="100%"
          >
            <TextField
              fullWidth
              label="Name"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              margin="normal"
            />
            <TextField
              fullWidth
              label="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              margin="normal"
            />
          </Box>

          {/* TYPE */}
          <TextField
            select
            fullWidth
            className="security-form-field"
            label="Type"
            value={connectType}
            onChange={(e) => setConnectType(e.target.value)}
          >
            <MenuItem value="USER">User</MenuItem>
            <MenuItem value="QUEUE">Queue</MenuItem>
            <MenuItem value="PHONE_NUMBER">Phone Number</MenuItem>
          </TextField>

          {/* USER TYPE CONFIG */}
          {connectType === "USER" && (
            <Box display="flex" gap={2} mt={2}>
              <TextField
                select
                fullWidth
                label="Select User"
                value={searchUser}
                onChange={(e) => setSearchUser(e.target.value)}
              >
                {userList.map((user, idx) => (
                  <MenuItem key={idx} value={user.userName}>
                    {user.userName}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                select
                fullWidth
                label="Flows"
                value={flow}
                onChange={(e) => setFlow(e.target.value)}
              >
                <MenuItem value="Default agent transfer">Default agent transfer</MenuItem>
                <MenuItem value="Flow2">Flow2</MenuItem>
              </TextField>
            </Box>
          )}

          {/* QUEUE TYPE CONFIG */}
          {connectType === "QUEUE" && (
            <Box display="flex" gap={2} mt={2}>
              <TextField
                select
                fullWidth
                label="Select Queue"
                value={searchQueue}
                onChange={(e) => setSearchQueue(e.target.value)}
              >
                {queueList.map((queue, idx) => (
                  <MenuItem key={idx} value={queue.queueName}>
                    {queue.queueName}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                select
                fullWidth
                label="Flows"
                value={queueFlow}
                onChange={(e) => setQueueFlow(e.target.value)}
              >
                <MenuItem value="Default queue transfer">Default queue transfer</MenuItem>
                <MenuItem value="FlowB">FlowB</MenuItem>
              </TextField>
            </Box>
          )}

          {/* PHONE NUMBER CONFIG */}
          {connectType === "PHONE_NUMBER" && (
            <Box display="flex" gap={2} mt={2}>

              <TextField
  select
  label="Country Code"
  value={countryCode}
  onChange={(e) => setCountryCode(e.target.value)}
  error={!!errors.countryCode}
  helperText={errors.countryCode && "Select a country code"}
  sx={{ minWidth: 200 }}
>
  {countryCodes.map((country, index) => (
    <MenuItem key={index} value={country.value}>
      {country.label}
    </MenuItem>
  ))}
</TextField>

              <TextField
                fullWidth
                label="Phone Number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />

             
            </Box>
          )}

          {/* TAG DISPLAY */}
          <Box mt={4}>
            <Typography 
              className="addqueue-tagsheading"
              sx={{ 
                textAlign: "left", 
                fontWeight: 600, 
                fontSize: "1.1rem", 
                color: "#333",
                m: 0, 
                p: 0 
              }}
            >
              Tags (Optional)
            </Typography>

            {Object.keys(tags).length === 0 ? (
              <Typography>No tags available</Typography>
            ) : (
              <Box mt={1} display="flex" gap={1} flexWrap="wrap">
                {Object.entries(tags).map(([key, value]) => (
                  <Chip key={key} label={`${key}: ${value}`} />
                ))}
              </Box>
            )}
          </Box>

          {/* ACTION BUTTONS */}
          <Box display="flex" justifyContent="flex-end" gap={2} mt={4}>
            <Button
              onClick={handleCancel}
              disabled={actionClicked === "save" || cancelButtonLoading}
            >
              {actionClicked === "cancel" ? <CircularProgress size={18} /> : "Cancel"}
            </Button>
            <Button 
              onClick={handleSubmit} 
              variant="contained"
              disabled={actionClicked === "cancel" || loading}
            >
              <span className="adduser-button-content">
                {actionClicked === "save" ? (
                  <CircularProgress size={18} style={{ color: "white" }} />
                ) : (
                  "Save"
                )}
              </span>
            </Button>
          </Box>
        </Box>
      </Container>
    </div>
  );
};

export default EditQuickConnectPage;